/**
 * 可显示自定义行数，超出时显示省略号的文本组件
 */
import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useMemo } from 'react';
import { getFixedWidthText } from '@gp/utils/utils';
import { Bubble } from 'tea-component';

function EllipsisText(props) {
  const {
    text = '', // 文本，必传
    lineNum = 1, // 行数
    textSize = 12, // 文字字体大小
    textWeight = 400, // 文字字体粗细
    buttonText, // 右下角按钮文字，不需要可不传,如果传了，则文本超出时才显示
    buttonTextSize = 12, // 右下角按钮字体大小
    buttonTextWeight = 400, // 右下角按钮字体粗细
    onClickButton, // 点击右下角按钮的回调
    overShowBubble, //文本超出是否需要bubble显示全部
    buttonShow = false, //是否显示右下角按钮
    bubbleClassName = '', 
  } = props;

  const textRef = useRef(null);
  if (!text) return <div ref={textRef}></div>;

  const [width, setWidth] = useState(0);

  const data = useMemo(() => {
    let finalText = text;
    let isOver = false;
    // 为了获取该组件的宽度，组件第一次render时按所有text文字显示
    if (width) {
      const sumWidth = width * lineNum;
      const str = getFixedWidthText(text, width, sumWidth, textSize, textWeight);
      // 如果返回有省略号，说明文字超出了范围
      if (str.endsWith('...')) {
        isOver = true;
      }
      if (isOver) {
        if (buttonText) {
          const span = document.createElement('span');
          span.style.visibility = 'hidden';
          span.style.padding = '0';
          span.style['white-space'] = 'nowrap';
          span.style['overflow-x'] = 'auto';
          span.style.fontSize =
            buttonTextSize > 12 ? buttonTextSize + 'px' : '12px';
          span.style.fontWeight = buttonTextWeight;
          document.body.appendChild(span);
          span.innerHTML = `...${buttonText}`;
          const sumWidth = width * lineNum - span.offsetWidth;
          document.body.removeChild(span);
          finalText = getFixedWidthText(
            text,
            width,
            sumWidth - 10,
            textSize,
            textWeight,
          );
        } else {
          finalText = str;
        }
      } else {
        finalText = text || '-';
      }
    }
    return {
      textStyle: {
        fontSize: `${textSize}px`,
        fontWeight: textWeight,
        wordBreak: 'break-all',
        position: 'relative',
        padding: 0,
        width: '100%'
      },
      finalText,
      isOver,
      buttonStyle: {
        fontSize: `${buttonTextSize}px`,
        fontWeight: buttonTextWeight,
        color: '#326ff0',
        cursor: 'pointer',
        padding: 0,
        float: 'right'
      },
    };
  }, [width, lineNum, text, buttonText, textSize, buttonTextSize]);

  const resizeWidth = useCallback(() => {
    if (textRef.current) {
      setWidth(textRef.current.getBoundingClientRect().width || 0);
    }
  }, []);

  useEffect(() => {
    // 组件didMound后获取组件的宽度
    resizeWidth();
  }, [textRef.current]);

  useEffect(() => {
    // 监听屏幕变化事件,修改组件的宽度
    window.addEventListener('resize', resizeWidth);
    return () => {
      window.removeEventListener('resize', resizeWidth);
    };
  }, []);

  return (
    <div style={data.textStyle} ref={textRef}>
      {overShowBubble&&data.isOver ? <Bubble
        className={bubbleClassName}
        arrowPointAtCenter
        placement="top"
        content={text||''}
        dark={true}
      >
        {data.finalText}
      </Bubble> : data.finalText
      }
      {buttonText && (data.isOver||buttonShow) && (
        <span
          style={data.buttonStyle}
          onClick={(e) => {
            onClickButton && onClickButton(e);
          }}
        >
          {buttonText}
        </span>
      )}
    </div>
  );
}

export default EllipsisText;
